<template>
  <div class="AuditRejected">
    <el-dialog
      title="填写驳回原因"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose">

      <el-form style="margin-top: 20px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
        <el-form-item label="驳回原因" prop="rejectReason">
          <el-input v-model="ruleForm.rejectReason" type="textarea" :rows="3" maxlength="500" size="small" placeholder="请输入驳回原因"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="" size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AuditRejected',
  data () {
    return {
      dialogVisible: false,
      ruleForm: {rejectReason: '',},
      rules: {
        rejectReason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.ruleForm.rejectReason = ''
    },
    submit() {
      this.$refs['ruleForm'].validate(async(valid) => {
        if (valid) {
          this.$emit('close', this.ruleForm.rejectReason)
          this.handleClose()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.AuditRejected {

}
</style>
